<template>
  <div>
    <template v-if="attachment.object.imageUrls">
      <img
        :src="attachment.object.imageUrls.medium"
        class="h-40 w-30 rounded-md cursor-pointer"
        @click="active = true"
      >

      <Teleport to="#modal-container">
        <template v-if="active">
          <div class="z-90000 fixed inset-0 h-screen w-screen flex items-center justify-center bg-gray-800/50 backdrop-blur" @click="active = false">
            <img
              :src="attachment.object.imageUrls.large"
              class="max-w-[90%] max-h-[90%] rounded-md pointer-events-none"
            >
          </div>
        </template>
      </Teleport>
    </template>

    <template v-else>
      <a :href="attachment.object.link" download target="_blank">
        <AttachmentEmbedContainer
          :title="attachment.object.caption"
          :info="attachment.object.extension"
          type="Attachment"
          icon="download"
        />
      </a>
    </template>
  </div>
</template>

<script setup lang="ts">
import AttachmentEmbedContainer from '../../embed/Container.vue'

interface Props {
  attachment: Record<string, any>
}

defineProps<Props>()

const active = ref(false)
</script>
